import type { SVGProps } from 'react';

const SvgCompanyInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M8 3C5.243 3 3 5.243 3 8v8c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5zm0 2h8c1.654 0 3 1.346 3 3v8c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3m9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5 1c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3"
    />
    <path
      fill="currentcolor"
      d="M2.95 16V8A5.055 5.055 0 0 1 8 2.95V3C5.243 3 3 5.243 3 8v8c0 2.757 2.243 5 5 5h8c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5v-.05A5.055 5.055 0 0 1 21.05 8v8A5.055 5.055 0 0 1 16 21.05H8A5.055 5.055 0 0 1 2.95 16M16 18.95V19H8v-.05zM18.95 16V8A2.954 2.954 0 0 0 16 5.05H8A2.954 2.954 0 0 0 5.05 8v8A2.954 2.954 0 0 0 8 18.95V19c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3v8c0 1.654-1.346 3-3 3v-.05A2.954 2.954 0 0 0 18.95 16M17 12c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5m-2.05 0A2.954 2.954 0 0 0 12 9.05 2.954 2.954 0 0 0 9.05 12 2.954 2.954 0 0 0 12 14.95V15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3v-.05A2.954 2.954 0 0 0 14.95 12M18 7a1 1 0 0 0-.227-.634l-.066-.073a1 1 0 0 0-1.414 0l-.066.073A1 1 0 1 0 18 7m-2-4.05V3H8v-.05zM17.05 12A5.055 5.055 0 0 1 12 17.05 5.055 5.055 0 0 1 6.95 12 5.055 5.055 0 0 1 12 6.95 5.055 5.055 0 0 1 17.05 12m1-5a1.05 1.05 0 1 1-2.1 0 1.05 1.05 0 0 1 2.1 0"
    />
  </svg>
);
export default SvgCompanyInstagram;
